import React, { useEffect, useState } from 'react';
import { Timer, Leaf } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function TopBanner() {
  const [timeLeft, setTimeLeft] = useState(15 * 60 + 25);
  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    };
    setCurrentDate(now.toLocaleDateString('es-ES', options).toUpperCase());
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="text-[#fdfaf1] py-2 px-4 text-center relative z-[60] overflow-hidden bg-[#1C621C]" data-id="element-295">
      {/* Decorative Herbs */}
      <div className="absolute left-0 top-0 opacity-20 pointer-events-none" data-id="element-296">
        <Leaf className="w-8 h-8 -rotate-45" data-id="element-297" />
      </div>
      <div className="absolute right-0 top-0 opacity-20 pointer-events-none" data-id="element-298">
        <Leaf className="w-8 h-8 rotate-45" data-id="element-299" />
      </div>

      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 md:gap-4 text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-300">
        <span className="hidden sm:inline opacity-70" data-id="element-301">{currentDate}</span>
        <span className="hidden sm:inline opacity-30" data-id="element-302">•</span>
        <p className="flex items-center gap-2 text-[11px] font-['DM_Sans',_sans-serif]" data-id="element-303">
          <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-304" />
          65% OFF SOLO POR HOY
        </p>
        <span className="opacity-30" data-id="element-305">•</span>
        <div className="flex items-center gap-1.5" data-id="element-306">
          <Timer className="w-3 h-3" data-id="element-307" />
          <span className="text-[11px]" data-id="element-308">
            TERMINA EN:{' '}
            <span className="font-black text-[13px] font-['DM_Sans',_sans-serif] text-[#EEF6F2]" data-id="element-309">
              {formatTime(timeLeft)}
            </span>
          </span>
        </div>
      </div>
    </div>;
}